import React from 'react'
import EstimateContainer from './EstimateContainer'

const Estimate = () => <EstimateContainer data-test="component-tradeIn-estimate" />

export default Estimate
